import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { UploadFileModel } from '../../models/upload-file.model'

// FIXME: Does not seem to be used, maybe to delete
@Component({
  selector: 'uploader-files',
  template: `
    @if (isVisible) {
      <mat-expansion-panel [expanded]="isExpanded" [hideToggle]="true">
        <mat-expansion-panel-header>
          <div class="flex flex-1 flex-align--center flex-gap-10px">
            @if (nbWaitingFiles) {
              <span translate [translateParams]="{ nb: nbWaitingFiles }"
                >WIDGET.UPLOAD.TITLE_UPLOADING</span
              >
            }
            @if (!nbWaitingFiles) {
              <span translate [translateParams]="{ nb: files.length }"
                >WIDGET.UPLOAD.TITLE_UPLOADED</span
              >
            }
            @if (nbWaitingFiles) {
              <mat-progress-spinner
                [diameter]="20"
                color="primary"
                mode="indeterminate"
              >
              </mat-progress-spinner>
            }
            <div class="flex-1"></div>
            <mat-icon aria-label="Close" (click)="close()">close</mat-icon>
          </div>
        </mat-expansion-panel-header>

        <mat-list>
          @for (file of files; track file.id; let last = $last) {
            <div>
              <mat-list-item>
                <div class="flex flex-fill flex-align--center">
                  <div class="flex-layout-column flex-75">
                    <div
                      class="flex-ellipsis fileName"
                      [title]="file.file.name"
                    >
                      {{ file.file.name }}
                    </div>
                    <div class="progressbar flex-25">
                      <div
                        class="inner-progressbar"
                        [style.width]="file.progress + '%'"
                      ></div>
                    </div>
                  </div>
                  <div class="flex-1"></div>
                  <div class="flex-60px flex flex-align-end--center">
                    @if (file.loaded) {
                      <mat-icon class="green-icon"> check_circle </mat-icon>
                    }
                    @if (file.inError) {
                      <mat-icon
                        color="primary"
                        class="clickable"
                        aria-label="Error"
                        [matTooltip]="file.errorDesc"
                        (click)="retryFile(file)"
                      >
                        error
                      </mat-icon>
                    }
                    <mat-icon
                      color="accent"
                      class="clickable"
                      aria-label="cancel"
                      (click)="cancelFile(file)"
                    >
                      cancel
                    </mat-icon>
                  </div>
                </div>
              </mat-list-item>
              @if (!last) {
                <mat-divider></mat-divider>
              }
            </div>
          }
        </mat-list>
      </mat-expansion-panel>
    }
  `,
  styleUrls: ['./uploader-files.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UploaderFilesComponent {
  @Input() files: UploadFileModel[] = []
  @Input() isExpanded: boolean
  @Input() isVisible: boolean
  @Input() nbWaitingFiles: number

  @Output() setIsExpandedEvent = new EventEmitter<boolean>()
  @Output() closeEvent = new EventEmitter<void>()
  @Output() cancelFileEvent = new EventEmitter<string>()
  @Output() retryFileEvent = new EventEmitter<UploadFileModel>()

  close(): void {
    this.closeEvent.emit()
  }

  cancelFile(file: UploadFileModel): void {
    this.cancelFileEvent.emit(file.id)
  }

  retryFile(file: UploadFileModel): void {
    this.retryFileEvent.emit(file)
  }

  public isUploading(): boolean {
    return this.files.some(file => !file.loaded && !file.inError)
  }
}
